import { createSelector } from '@reduxjs/toolkit';
import { selectApartmentsValue } from './selectApartmentsValue';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Без апартаментов', value: false },
  { label: 'Только апартаменты', value: true },
];

export const selectApartmentsFilter = createSelector(selectApartmentsValue, apartment => ({
  label: 'Апартаменты',
  value: [apartment],
  options: OPTIONS,
}));
